// Visuell rendering av DividerBlock — bara en horisontell linje med justerbar färg.

import { Box } from '@mui/material';
import { DividerBlock } from '../types';

type Props = { block: DividerBlock };

export const DividerBlockView = ({ block }: Props) => {
  const color = block.color ?? '#dddddd';
  return (
    <Box sx={{ p: '12px 30px' }}>
      <Box component='hr' sx={{ border: 0, borderTop: `1px solid ${color}`, m: 0 }} />
    </Box>
  );
};

export default DividerBlockView;
